"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Player = void 0;
var Widget_1 = require("../tools/Widget");
var Player = (function (_super) {
    __extends(Player, _super);
    function Player() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.playerInterval = null;
        _this.playerPoll = null;
        return _this;
    }
    Player.prototype.getPlayerType = function () {
        return this.playerType;
    };
    Player.prototype.init = function () {
        var _this = this;
        window.addEventListener("load", function (event) {
            _this.isSafari = window.Meister.Browser.isSafari
                ? window.Meister.Browser.isSafari
                : false;
            _this.playerType = _this.el.data("type");
            _this.activePlayer = window.playerProperties.activePlayer;
            _this.BNRArchivePlayer = window.BNRPlayer;
            _this.playerImage = window.playerProperties.image;
            window.onbeforeunload = _this.beforeUnload.bind(_this);
            _this.totalTimeSpent = 0;
            _this.elapsedIntervalAmount = 0;
            _this.isPlaying = false;
            _this.maxInterVal = 30;
            var meisterPlayerConfig = {
                global: {
                    autoplay: true,
                    defaultAudioImage: _this.playerImage,
                    iosPlaysInline: true,
                },
                AdItem: {},
                GoogleIma: {
                    scriptUrl: "https://imasdk.googleapis.com/js/sdkloader/ima3.js",
                    onImaAvailable: function () {
                        window.google.ima.settings.setNumRedirects(4);
                        window.google.ima.settings.setVpaidMode(window.google.ima.ImaSdkSettings.VpaidMode.INSECURE);
                    },
                },
                Hls: {
                    disabled: _this.isSafari,
                },
                HtmlUi: {
                    standard: {
                        stepBack: 10,
                        stepForward: 10,
                        qualityMapping: [
                            {
                                from: -1,
                                to: 0,
                                resolution: "auto",
                            },
                            {
                                from: 0,
                                to: 200000,
                                resolution: "160p",
                            },
                            {
                                from: 200000,
                                to: 1200000,
                                resolution: "360p",
                            },
                            {
                                from: 1200000,
                                to: 2850000,
                                resolution: "720p",
                            },
                            {
                                from: 2850000,
                                to: 6000000,
                                resolution: "1080p",
                            },
                        ],
                    },
                    ui: "<div class=\"mstr-container\" data-mstr-directive=\"autoHideShow,togglePlayPauseClick\">\n                          <div class=\"mstr-centerbar\">\n                              <span data-mstr-standard=\"spinner\"></span>\n                          </div>\n                          <div class=\"mstr-bottombar\">\n                              <div class=\"mstr-items\">\n                                  <div class=\"mstr-item\">\n                                      <span data-mstr-standard=\"playbutton\"></span>\n                                  </div>\n                                  <div class=\"mstr-item\">\n                                      <span data-mstr-standard=\"stepbackbutton\"></span>\n                                  </div>\n                                  <div class=\"mstr-item mstr-item--fill\">\n                                      <span data-mstr-standard=\"seekbar\"></span>\n                                  </div>\n                                  <div class=\"mstr-item\">\n                                      <span data-mstr-standard=\"timedisplay\"></span>\n                                  </div>\n                                  <div class=\"mstr-item\">\n                                      <span data-mstr-standard=\"volumeslider\"></span>\n                                  </div>\n                              </div>\n                          </div>\n                      </div>",
                },
            };
            if (_this.activePlayer === "audioArchiveFragmentPlayer") {
                _this.startMeisterArchivePlayer(meisterPlayerConfig, window.playerProperties);
            }
            else if (_this.activePlayer === "liveAudioPlayer" ||
                _this.activePlayer === "liveVideoPlayer" ||
                _this.activePlayer === "audioFragmentPlayer") {
                _this.startMeisterPlayer(meisterPlayerConfig, window.playerProperties);
            }
        });
    };
    Player.prototype.startMeisterArchivePlayer = function (meisterPlayerConfig, playerProperties) {
        var startTime = playerProperties.startTime / 1000;
        var duration = playerProperties.stopTime / 1000 - startTime;
        var MeisterArchivePlayer = new this.BNRArchivePlayer({
            element: ".meisterplayer",
            starttime: startTime,
            duration: duration,
            src: window.playerProperties.src,
            config: meisterPlayerConfig,
            item: { mediaType: "audio" },
        });
        this.meisterplayer = MeisterArchivePlayer.player;
        this.archiveFragmentStartTime = this.formatDate(new Date(playerProperties.startTime));
        this.clientStartTime = this.getCurrentTime();
        this.meisterPlayerEvents();
    };
    Player.prototype.startMeisterPlayer = function (meisterPlayerConfig, playerProperties) {
        var _this = this;
        var meisterPlayer = new Meister(".meisterplayer", meisterPlayerConfig);
        this.meisterplayer = meisterPlayer;
        this.meisterplayer.setItem({
            type: "aditem",
            media: playerProperties,
        });
        if (this.isSafari) {
            this.meisterplayer.one("adBreakEnded", function () {
                if (_this.meisterplayer.playerPlugin.mediaElement.src !==
                    playerProperties.src) {
                    _this.meisterplayer.playerPlugin.mediaElement.src =
                        playerProperties.src;
                }
            });
        }
        this.meisterplayer.load();
        this.meisterPlayerEvents();
    };
    Player.prototype.meisterPlayerEvents = function () {
        var _this = this;
        var bus = Widget_1.Widget.getBus();
        this.meisterplayer.on("playerCreated", function () {
            _this.currentPlayerVolume = _this.meisterplayer.volume;
        });
        this.meisterplayer.on("playerPlaying", function () {
            _this.isPlaying = true;
            bus.notify(_this.activePlayer + ".play", _this.getData());
            _this.startAudioFragmentPercentageInterval();
            _this.startPlayerPoll();
        });
        this.meisterplayer.on("playerPause", function () {
            _this.isPlaying = false;
            bus.notify(_this.activePlayer + ".pause", _this.getData());
            _this.clearAudioFragmentPercentageInterval();
        });
        this.meisterplayer.on("playerBuffering", function () {
            _this.isPlaying = false;
            _this.clearAudioFragmentPercentageInterval();
        });
        this.meisterplayer.on("playerEnd", function () {
            _this.isPlaying = false;
            bus.notify(_this.activePlayer + ".end", _this.getData());
            if (_this.activePlayer === "audioFragmentPlayer") {
                _this.currentFragmentPercentage = 100;
                Widget_1.Widget.getBus().notify(_this.activePlayer + ".percentage", _this.getData());
            }
            _this.clearAudioFragmentPercentageInterval();
            _this.handleFragmentEnd();
        });
        var playerVolumeChangeEvent = this.debounce(function () {
            _this.playerVolumeChangeEvent();
        }, 3000);
        this.meisterplayer.on("playerVolumeChange", playerVolumeChangeEvent);
    };
    Player.prototype.handleFragmentEnd = function () {
        return __awaiter(this, void 0, void 0, function () {
            var episode, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.getNextEpisode()];
                    case 1:
                        episode = _a.sent();
                        if (episode === null || episode === void 0 ? void 0 : episode.hasNextAudio) {
                            window.location = "/player/audio/" + episode.audioId + "/" + episode.articleId;
                        }
                        return [3, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Player.prototype.getNextEpisode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var siteData, req;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        siteData = window.siteData;
                        if (!siteData.subSection || !siteData.articleId) {
                            return [2, {}];
                        }
                        return [4, fetch("/player/next/audio/" + siteData.subSection + "/" + siteData.articleId).then(function (res) { return res; })];
                    case 1:
                        req = _a.sent();
                        return [4, req.json()];
                    case 2: return [2, _a.sent()];
                }
            });
        });
    };
    Player.prototype.playerVolumeChangeEvent = function () {
        Widget_1.Widget.getBus().notify(this.activePlayer + ".volume", this.getData());
        this.currentPlayerVolume = Meister.instances[0].instance.volume;
    };
    Player.prototype.debounce = function (func, delay) {
        var timeoutId;
        return function () {
            var args = arguments;
            clearTimeout(timeoutId);
            timeoutId = setTimeout(function () {
                func.apply(null, args);
            }, delay);
        };
    };
    Player.prototype.beforeUnload = function () {
        var bus = Widget_1.Widget.getBus();
        if (Meister.instances.length) {
            this.endDate = this.getCurrentTime();
            bus.notify(this.activePlayer + ".close", this.getData());
        }
    };
    Player.prototype.startAudioFragmentPercentageInterval = function () {
        var _this = this;
        var meisterInstance = Meister.instances[0].instance;
        if (this.activePlayer === "audioFragmentPlayer") {
            this.playerInterval = setInterval(function () {
                _this.audioFragmentPercentageEvent();
            }, meisterInstance.duration * 10);
        }
    };
    Player.prototype.clearAudioFragmentPercentageInterval = function () {
        if (this.activePlayer === "audioFragmentPlayer") {
            clearInterval(this.playerInterval);
        }
    };
    Player.prototype.startPlayerPoll = function () {
        var _this = this;
        clearInterval(this.playerPoll);
        this.playerPoll = setInterval(function () {
            if (_this.isPlaying) {
                _this.elapsedIntervalAmount += 1;
                _this.totalTimeSpent += 1;
                if (_this.elapsedIntervalAmount >= _this.maxInterVal) {
                    _this.elapsedIntervalAmount = 0;
                    _this.playerPollEvent();
                }
            }
        }, 1000);
    };
    Player.prototype.playerPollEvent = function () {
        if (this.activePlayer === "audioFragmentPlayer" ||
            this.activePlayer === "audioArchiveFragmentPlayer") {
            Widget_1.Widget.getBus().notify(this.activePlayer + ".listeningtime", this.getData());
        }
    };
    Player.prototype.audioFragmentPercentageEvent = function () {
        var percentages = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
        var meisterInstance = Meister.instances[0].instance;
        var currentPercentage = Math.floor((meisterInstance.currentTime / meisterInstance.duration) * 100);
        for (var i = 0; i < percentages.length; i++) {
            if (currentPercentage == percentages[i] &&
                (!this.currentFragmentPercentage ||
                    (this.currentFragmentPercentage &&
                        this.currentFragmentPercentage != currentPercentage))) {
                this.currentFragmentPercentage = currentPercentage;
                Widget_1.Widget.getBus().notify(this.activePlayer + ".percentage", this.getData());
            }
        }
    };
    Player.prototype.getCurrentTime = function (date) {
        if (date === void 0) { date = new Date(); }
        function pad(value) {
            return ("00" + value).slice(-2);
        }
        var hours = pad(date.getHours());
        var minutes = pad(date.getMinutes());
        return [hours, minutes].join(":");
    };
    Player.prototype.formatDate = function (d) {
        function pad(n) {
            return n < 10 ? "0" + n : n;
        }
        return (pad(d.getDate()) +
            "-" +
            pad(d.getMonth() + 1) +
            "-" +
            d.getFullYear() +
            " " +
            pad(d.getHours()) +
            ":" +
            pad(d.getMinutes()) +
            ":" +
            pad(d.getSeconds()));
    };
    Player.prototype.getData = function () {
        var meisterInstance = Meister.instances[0].instance;
        var data = {
            playerElapsed: Math.floor(meisterInstance.currentTime),
            playerStarted: this.clientStartTime,
            currentItem: meisterInstance.currentItem,
            duration: Math.floor(meisterInstance.duration),
            endDate: this.getCurrentTime() || "",
            fragmentDate: this.archiveFragmentStartTime || "",
            currentPercentage: this.currentFragmentPercentage || "",
            timeSpent: this.totalTimeSpent || 0,
            currentPlayerVolume: Math.round(this.currentPlayerVolume * 100).toFixed(),
            newPlayerVolume: Math.round(meisterInstance.volume * 100).toFixed(),
        };
        return data;
    };
    return Player;
}(Widget_1.Widget));
exports.Player = Player;
